import { BrowserRouter, Routes, Route } from "react-router-dom"
import HeroSection from "./pages/heroSection/HeroSection"
import Contact from "./pages/contact/Contact"
import Product from "./pages/product/Product"
import ProductDetail from "./pages/productDetails/ProductDetail"
import PrivacyPolicy from "./pages/privacyPolicy/PrivacyPolicy"

const AllPages = () => (
  <>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HeroSection />}></Route>
        <Route path="/contact" element={<Contact />}></Route>
        <Route path="/product" element={<Product />}></Route>
        <Route path={`/product/:id`} element={<ProductDetail />}>
          {" "}
        </Route>
        <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
      </Routes>
    </BrowserRouter>
  </>
)

export default AllPages
